import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm, useDataRefresh} from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import PropTypes from 'prop-types';
import { MLSideMenuItemsService } from 'ml-services-common-react';

import metadata from './SideMenuComponent.metadata.json5';
import styles from './SideMenuComponent.module.scss';

const SideMenuComponent = (props) => {
    const { policySummaries } = props;

    const [isPolicySummaryLoaded, setIsPolicySummaryLoaded ] = useState(false);
    const [sideMenuItems, setSideMenuItems] = useState([]);

    const translator = useTranslator();

    useEffect(() => {
        if(!isPolicySummaryLoaded && policySummaries){
            setSideMenuItems(MLSideMenuItemsService.getItems(3, policySummaries));
            setIsPolicySummaryLoaded(true);
        }
    },[policySummaries]);

    const generateSideMenuContentOverrides = () => {
        const overrides = sideMenuItems.map((sideMenuItem, index) => {
            return {
                [`sideMenuHeader${index}`]: {
                    content: translator(sideMenuItem.title)
                },
                [`sideMenuVerbiage${index}`]: {
                    content: translator(sideMenuItem.verbiage)
                },
                [`sideMenuButton${index}`]: {
                    content: translator(sideMenuItem.buttonText),
                    onClick: sideMenuItem.action,
                    mlTagManagerLinkClick: `Dashboard_quickLinks_${translator(sideMenuItem.buttonText)}`
                }
            }
        });
        return Object.assign({}, ...overrides);
    }
    
    const overrideProps  = {
        sideMenuContentIterable: {
            data: sideMenuItems
        },
        ...generateSideMenuContentOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    };
    
    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

SideMenuComponent.propTypes = {
    policySummaries: PropTypes.array.isRequired
};

export default SideMenuComponent;